import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import AttorneyLeftSidebarTwoGridSectionOne from '../../components/attorney-components/AttorneyLeftSidebarTwoGridSectionOne';
import FooterOne from '../../common/footer/FooterOne';

const AttorneyLeftSidebarTwoGridOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Attorney Left Sidebar Two Grid 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Attorney Left Sidebar Two Grid 1"
        />
        
        <AttorneyLeftSidebarTwoGridSectionOne />
        
        <FooterOne />
        </>
    )
}
    
export default AttorneyLeftSidebarTwoGridOne;